import React from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardHeaderActions,
  CardTitle,
  CardTitleCount,
} from 'components/Card'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import Prompt from './Prompt'
import { SectionError, SectionLoading } from '../Section/Section'
import { JobCardEmptyState } from '../JobCardEmptyState'
import Button from 'components/Button'

interface Props {
  vm: JobViewModel
}

export default observer(function PromptsCard({ vm }: Props) {
  const scrollProvider = vm.detailsVM.promptsList.scrollProvider

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Prompts
          <CardTitleCount>
            ({vm.detailsVM.promptsList.prompts.length})
          </CardTitleCount>
        </CardTitle>
        <CardHeaderActions>
          {vm.canCreatePrompt && (
            <IconButton
              onClick={vm.createPromptVM.show}
              data-test="create-prompt-dropdown-item"
            >
              <Icon name="add" />
            </IconButton>
          )}
        </CardHeaderActions>
      </CardHeader>
      {scrollProvider.fetch.match({
        pending: () => (
          <CardContent>
            <SectionLoading />
          </CardContent>
        ),
        rejected: (err) => (
          <>
            <CardContent>
              <SectionError
                title="An error occurred while loading prompts."
                error={err}
              />
            </CardContent>
          </>
        ),
        resolved: () => (
          <CardContent scroll listContent>
            {vm.detailsVM.promptsList.prompts.length > 0 ? (
              <>
                {vm.detailsVM.promptsList.prompts.map((p, _) => (
                  <Prompt
                    key={p.prompt.id}
                    vm={p}
                    reviewVM={vm.reviewPromptVM}
                  />
                ))}
                {!scrollProvider.isDone && (
                  <InfiniteScrollLoader scrollProvider={scrollProvider} />
                )}
              </>
            ) : (
              <JobCardEmptyState
                helpText={
                  'Use Prompts to create and send prominent questions to clients for response. Track all answered and unanswered replies here.'
                }
              >
                {vm.canCreatePrompt && (
                  <Button
                    onClick={vm.createPromptVM.show}
                    data-test="create-prompt-dropdown-item"
                    type="text"
                  >
                    Send a prompt
                  </Button>
                )}
              </JobCardEmptyState>
            )}
          </CardContent>
        ),
      })}
    </Card>
  )
})
